import { translate } from "../i18n";
export const NAV = [["top", translate("Home")], ["prodotti", translate("Prodotti")], ["servizi", translate("La stampa")], ["storia", translate("La nostra storia")], ["contatti", translate("Contatti")], ["questo-mese", translate("Questo mese")]];
